
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.14 28.14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 2507","fill":"#243882","d":"M0 0h28.14v28.14H0z"}})])]),_c('g',{attrs:{"data-name":"Group 4213","clip-path":"url(#a)","fill":"#243882"}},[_c('path',{attrs:{"data-name":"Path 26052","d":"M26.557 0H7.174a1.582 1.582 0 00-1.583 1.583v3.376h15.375a2.218 2.218 0 012.215 2.215v15.375h3.376a1.582 1.582 0 001.583-1.583V1.583A1.582 1.582 0 0026.557 0"}}),_c('path',{attrs:{"data-name":"Path 26053","d":"M20.966 5.591H1.583A1.582 1.582 0 000 7.174v19.384a1.582 1.582 0 001.583 1.582h19.383a1.582 1.582 0 001.583-1.582V7.174a1.582 1.582 0 00-1.583-1.583m-4.124 12.684h-4.048v4.4H9.755v-4.4H5.707v-2.818h4.048v-4.4h3.04v4.4h4.047z"}})])])
          )
        }
      }
    